import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { firestore } from '../../../firebase';
import PlayerStats from '../../Public/Player/PlayerStats';
import AddStatsPlayer from './AddStatsPlayer';

function PlayerDetails() {

    const {id} = useParams();

    const [player, setPlayer] = useState();

    const [name, setName] = useState("")
    const [image, setImage] = useState("");
    const [team, setTeam] = useState("")

    const [totalFixtures, setTotalFixtures] = useState(0);
    const [totalGoals, setTotalGoals] = useState(0);
    const [totalAssists, setTotalAssists] = useState(0);

    const [number, setNumber] = useState(0)

    const [message, setMessage] = useState("")

    useEffect(() => {

        try {
            const playerRef = firestore.collection("players-fb").doc(id);
            playerRef.onSnapshot(doc => {
                const player = {id: doc.id, ...doc.data()}
                setPlayer(player)
                setImage(player.player_image)
                setName(player.player_name)
                setTeam(player.player_team)
                setTotalFixtures(player.player_total_fixtures)
                setTotalGoals(player.player_total_goals)
                setTotalAssists(player.player_total_assists)
                setNumber(player.player_number)
            })
            
        } catch (error) {
            
        }

    }, [id])

    async function editPlayer(e) {
        e.preventDefault();
        try {
            const playerRef = firestore.collection("players-fb").doc(id);
            const data = {
                player_name: name,
                player_image: image,
                player_team: team,
                player_total_fixtures: +totalFixtures,
                player_total_goals: +totalGoals,
                player_total_assists: +totalAssists,
                player_number: number
            }
            playerRef.update(data)
            setMessage("Oppdatert")
        } catch (error) {
            setMessage(error.message)
        }
    }

    return (
        <div className="container my-5">
            <div className="col-lg-8 mx-auto">
                <form onSubmit={editPlayer}>
                    <label>Navn</label>
                    <input value={name} onChange={e => setName(e.target.value)} className="form-control mb-2"  />

                    <label>Bilde</label>
                    <input value={image} onChange={e => setImage(e.target.value)} className="form-control mb-2" />

                    <div className="col-lg-2 col-md-4 my-3">
                        <img src={image} />
                    </div>

                    <div className="form-group">
                        <label>Nåværende lag</label>
                        <input className="form-control mb-2" value={team} onChange={e => setTeam(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label>Draktnummer</label>
                        <input type="number"  className="form-control mb-2" value={number} onChange={e => setNumber(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label>Totalt antall kamper i karrieren</label>
                        <input type="number"  className="form-control mb-2" value={totalFixtures} onChange={e => setTotalFixtures(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>Totalt antall mål i karrieren</label>
                        <input  type="number" className="form-control mb-2" value={totalGoals} onChange={e => setTotalGoals(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>Totalt antall assist i karrieren</label>
                        <input type="number"  className="form-control mb-2" value={totalAssists} onChange={e => setTotalAssists(e.target.value)} />
                    </div>

                    {message && <p>{message}</p>}
                    <button className="btn btn-primary btn-rounded">Lagre endringer</button>
                </form>

                <h2 className="mt-4">Legg til statistikk</h2>
                <AddStatsPlayer player={player} />
                <PlayerStats playerId={player?.id} />
            </div>
        </div>
    )
}
export default PlayerDetails